import React from 'react';
import TeacherAvailabilityAdminPage from '../domains/admin/components/TeacherAvailabilityAdminPage';

const AdminTeacherAvailabilityPage: React.FC = () => {
  return <TeacherAvailabilityAdminPage />;
};

export default AdminTeacherAvailabilityPage;

